// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
import { url2md5 } from 'pub_config';
import { md5hola } from '../util.js';
import { www_hola } from 'hola_opt';
export var cp_url = '/cp';
export var get_tab = path => path.replace(cp_url, '').replace('/', '') || 'overview';
export var img_url = name => url2md5(`/www/hola/pub/img/account/${name}`);
export var get_icon_urls = id => {
  if (www_hola && www_hola.split_svg_sprites) {
    var path1 = `/www/hola/pub/img/svg/icon/${id}_1.svg`;
    var path2 = `/www/hola/pub/img/svg/icon/${id}_2.svg`;
    return [`${md5hola(path1)}#${id}_1`, `${md5hola(path2)}#${id}_2`];
  }
  var path = md5hola('/www/hola/pub/img/icons.svg');
  return [`${path}#${id}_1`, `${path}#${id}_2`];
};